var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var $ = require("./lib/qsa");

var quiz = null;
var results = null;
var pymChild = null;

var numTaken = 0;
var numCorrect = 0;
var numWrong = 0;
var numRemaining = 0;
var promptsRight = [];
var promptsWrong = [];

function initVideoForQuestion(wrapper) {
  var videoEl = wrapper.querySelector(".player");
  if (!videoEl) {
    console.log("No video element found in wrapper");
    return;
  }

  var src = videoEl.getAttribute('data-src');
  var srcMobile = videoEl.getAttribute('data-src-mobile');

  console.log("Desktop src:", src);
  console.log("Mobile src:", srcMobile);
  console.log("Is mobile:", window.matchMedia("(max-width: 600px)").matches);

  var finalSrc = src;
  if (srcMobile && window.matchMedia("(max-width: 600px)").matches) {
    finalSrc = srcMobile;
  }

  console.log("Final src:", finalSrc);

  if (!finalSrc) {
    console.log("No source URL found");
    return;
  }

  videoEl.setAttribute('muted', '');
  videoEl.setAttribute('playsinline', '');
  videoEl.setAttribute('webkit-playsinline', '');
  videoEl.setAttribute('preload', 'auto');
  videoEl.muted = true;
  videoEl.playsInline = true;
  
  var source = document.createElement('source');
  source.src = finalSrc;
  source.type = 'video/mp4';
  
  videoEl.innerHTML = '';
  videoEl.appendChild(source);
  
  videoEl.addEventListener('loadedmetadata', function() {
    console.log("Video metadata loaded");
    videoEl.currentTime = 0;
  }, { once: true });
  
  videoEl.addEventListener('error', function(e) {
    console.error("Video error:", e);
  });
  
  videoEl.load();
  console.log("Video load initiated");
}

var onWindowLoaded = function () {
  quiz = document.querySelector("#quiz");
  results = document.querySelector("#results");

  promptsRight = PROMPTS.filter(d => d.type == "right");
  promptsWrong = PROMPTS.filter(d => d.type == "wrong");

  var allWrappers = quiz.querySelectorAll(".question-wrapper");
  allWrappers.forEach(wrapper => {
    initVideoForQuestion(wrapper);
  });

  initNextQuestion(1);

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
};

var clearCurrentQuestion = function (qNum) {
  var wrapper = quiz.querySelector(".question-wrapper[data-question='" + qNum + "']");
  wrapper.classList.remove("current");

  wrapper.querySelector(".question").classList.add("answered");

  var answers = wrapper.querySelectorAll("button");
  answers.forEach(a => {
    a.removeEventListener("click", onAnswerClicked);
    a.disabled = true;
  });
};

var initNextQuestion = function (qNum) {
  var wrapper = quiz.querySelector(".question-wrapper[data-question='" + qNum + "']");
  wrapper.classList.add("active");
  wrapper.classList.add("current");

  var videoEl = wrapper.querySelector(".player");
  if (videoEl) {
    try {
      videoEl.play();
    } catch (err) {
    }
  }

  var answers = wrapper.querySelectorAll("button");
  answers.forEach(a => {
    a.disabled = false;
    a.addEventListener("click", onAnswerClicked);
  });
};

var onAnswerClicked = function (evt) {
  var clickedBtn = evt.target;
  var questionBlock = clickedBtn.closest(".question");
  var qNum = Number(questionBlock.parentNode.dataset.question);
  var resultsMsg = '';

  clearCurrentQuestion(qNum);

  numTaken++;
  numRemaining = NUM_QUESTIONS - numTaken;

  var isCorrect = clickedBtn.closest("li").classList.contains("correct");
  var label = document.createElement("b");

  if (isCorrect) {
    numCorrect++;
    label.textContent =
      promptsRight[Math.floor(Math.random() * promptsRight.length)].message;
  } else {
    numWrong++;
    label.textContent =
      promptsWrong[Math.floor(Math.random() * promptsWrong.length)].message;
  }

  clickedBtn.prepend(label);
  clickedBtn.closest("li").classList.add("selected");

  var selectedLi = clickedBtn.closest("li");
  var answerDescription = selectedLi.querySelector(".answer");
  if (answerDescription) {
    answerDescription.style.display = "block";
  }

  if (numTaken == NUM_QUESTIONS) {
    results.classList.add("final");

    var topline = results.querySelector("#answered-correct");
    if (topline) topline.innerHTML = numCorrect;

    if (numCorrect < 2) {
      resultsMsg += FINAL_LOW;
    } else if (numCorrect == 2) {
      resultsMsg += FINAL_MID;
    } else if (numCorrect > 2) {
      resultsMsg += FINAL_HIGH;
    }

    var finalResults = results.querySelector("#final-results");
    finalResults.innerHTML = resultsMsg;

    ANALYTICS.trackEvent("questions-answered", NUM_QUESTIONS);
    ANALYTICS.trackEvent("question-" + qNum + "-answered", isCorrect ? "correct" : "incorrect");
  } else {
    results.classList.add("active");

    var counter = results.querySelector("#answered-count");
    if (counter) counter.innerHTML = numTaken;

    initNextQuestion(qNum + 1);

    ANALYTICS.trackEvent("questions-answered", numTaken);
    ANALYTICS.trackEvent("question-" + qNum + "-answered", isCorrect ? "correct" : "incorrect");
  }

  if (pymChild) {
    pymChild.sendHeight();
  }
};

window.addEventListener("load", onWindowLoaded);
